import { Tooltip, icons } from '@lifebit-ai/lds'
import React from 'react'

import { StyledLoader } from 'modules/resultsV2/DownloadResultFile.styles'
import { useDownloadDataAccessRequestParticipantFile } from 'services/data-access-requests/hooks/useDownloadDataAccessRequestParticipantFile'

import * as styles from './DownloadDataAccessRequestParticipantFile.styles'

export const DOWNLOAD_DATA_ACCESS_REQUEST_PARTICIPANT_FILE_TEST_ID = 'download-data-access-request-participant-file'
export const DOWNLOAD_DATA_ACCESS_REQUEST_PARTICIPANT_FILE_LABEL = 'Download person ID file'

interface DownloadDataAccessRequestParticipantFileProps {
  requestId: string
}

export const DownloadDataAccessRequestParticipantFile = ({
  requestId
}: DownloadDataAccessRequestParticipantFileProps): JSX.Element => {
  const mutation = useDownloadDataAccessRequestParticipantFile()
  const isLoading = mutation.isPending

  return (
    <Tooltip title="Download file">
      <styles.DownloadButton
        type="button"
        aria-label={DOWNLOAD_DATA_ACCESS_REQUEST_PARTICIPANT_FILE_LABEL}
        aria-busy={isLoading}
        aria-disabled={isLoading}
        disabled={isLoading}
        data-testid={DOWNLOAD_DATA_ACCESS_REQUEST_PARTICIPANT_FILE_TEST_ID}
        onClick={() => mutation.mutate({ requestId })}
      >
        {isLoading ? <StyledLoader text={false} /> : <icons.DownloadSmall />}
      </styles.DownloadButton>
    </Tooltip>
  )
}
